export const APP_NAME = 'Centraide';
export const APP_SEPARATOR = '-';
